import { XnLazyModules } from "./xn-lazymodule/types/xn-lazymodule.type";


export const XN_LAZY_MODULES: XnLazyModules = [
  // begin test lazy component
  {
    key: 'component1',
    load: () => import('./test-lazy-module/component1/component1.module').then(m => m.Component1Module),
  },
  {
    key: 'component2',
    load: () => import('./test-lazy-module/component2/component2.module').then(m => m.Component2Module)
  },
  {
    key: 'component3',
    load: () => import('./test-lazy-module/component3/component3.module').then(m => m.Component3Module)
  },
  // end test lazy component
  {
    key: 'pre-arrival-step-1',
    load: () => import('./pre-arrival/pre-arrival-steps/video-step/video-step.module').then(m => m.VideoStepModule),
  },
  {
    key: 'pre-arrival-step-2',
    load: () => import('./pre-arrival/pre-arrival-steps/pre-arrival-step2/pre-arrival-step2.module').then(m => m.PreArrivalStep2Module)
  },
  {
    key: 'pre-arrival-step-3',
    load: () => import('./pre-arrival/pre-arrival-steps/pre-arrival-step3/pre-arrival-step3.module').then(m => m.PreArrivalStep3Module)
  },
  {
    key: 'pre-arrival-step-4',
    load: () => import('./pre-arrival/pre-arrival-steps/pre-arrival-step4/pre-arrival-step4.module').then(m => m.PreArrivalStep4Module)
  },
  {
    key: 'pre-arrival-step-5',
    load: () => import('./pre-arrival/pre-arrival-steps/pre-arrival-step5/pre-arrival-step5.module').then(m => m.PreArrivalStep5Module)
  },
  {
    key: 'pre-arrival-html-step',
    load: () => import('./pre-arrival/pre-arrival-steps/html-step/html-step.module').then(m => m.HtmlStepModule)
  },
  {
    key: 'pre-arrival-video-step',
    load: () => import('./pre-arrival/pre-arrival-steps/video-step/video-step.module').then(m => m.VideoStepModule)
  },
  // Apply application steps
  {
    key: 'apply-static-step',
    load: () => import('./apply-application/apply-application-step/steps/apply-static-step/apply-static-step.module').then(m => m.ApplyStaticStepModule)
  },
  {
    key: 'apply-profile-contact',
    load: () => import('./apply-application/apply-application-step/steps/apply-profile-contact/apply-profile-contact.module').then(m => m.ApplyProfileContactModule)
  },
  {
    key: 'apply-car',
    load: () => import('./apply-application/apply-application-step/steps/apply-car/apply-car.module').then(m => m.ApplyCarModule)
  },
  {
    key: 'apply-pets',
    load: () => import('./apply-application/apply-application-step/steps/apply-pets/apply-pets.module').then(m => m.ApplyPetsModule)
  },
  {
    key: 'apply-occupants',
    load: () => import('./apply-application/apply-application-step/steps/apply-occupants/apply-occupants.module').then(m => m.ApplyOccupantsModule)
  },
  {
    key: 'apply-guarantors',
    load: () => import('./apply-application/apply-application-step/steps/apply-guarantors/apply-guarantors.module').then(m => m.ApplyGuarantorsModule)
  },
  {
    key: 'apply-residential-history',
    load: () => import('./apply-application/apply-application-step/steps/apply-residential-history/apply-residential-history.module').then(m => m.ApplyResidentialHistoryModule)
  },
  {
    key: 'apply-employment-history',
    load: () => import('./apply-application/apply-application-step/steps/apply-employment-history/apply-employment-history.module').then(m => m.ApplyEmploymentHistoryModule)
  },
  {
    key: 'apply-personal-references',
    load: () => import('./apply-application/apply-application-step/steps/apply-personal-references/apply-personal-references.module').then(m => m.ApplyPersonalReferencesModule)
  },
  {
    key: 'apply-document-check',
    load: () => import('./apply-application/apply-application-step/steps/apply-document-check/apply-document-check.module').then(m => m.ApplyDocumentCheckModule)
  },
  {
    key: 'electronic-background-check',
    load: () => import('./apply-application/apply-application-step/steps/electronic-background-check/electronic-background-check.module').then(m => m.ElectronicBackgroundCheckModule)
  },
  {
    key: 'apply-application-summary',
    load: () => import('./apply-application/apply-application-step/steps/apply-application-summary/apply-application-summary.module').then(m => m.ApplyApplicationSummaryModule)
  },
  {
    key: 'application-submitted',
    load: () => import('./apply-application/apply-application-step/steps/application-submitted/application-submitted.module').then(m => m.ApplicationSubmittedModule)
  },
]